/* eslint-disable import/prefer-default-export */
import { makeStyles } from '@material-ui/core/styles';

export const itemsStyles = makeStyles(() => ({
  section: {
    paddingBottom: 115,
  },
  title: {
    textAlign: 'center',
    marginBottom: 60,
  },
  subtitle: {
    paddingBottom: 20,
    marginBottom: 24,
    borderBottom: '1px solid #CFC4C5',
  },
  card: {
    minHeight: '340px!important',
  },
  tags: {
    marginRight: -16,
    marginBottom: 54,
  },
  tag: {
    marginBottom: 16,
    marginRight: 16,
  },
  activeTag: {
    backgroundColor: '#EBE6E2',
  },
  itemsWithBg: {
    position: 'relative',
    '&::before': {
      content: "' '",
      display: 'block',
      position: 'absolute',
      bottom: -20,
      left: 0,
      right: 0,
      width: '100%',
      height: 100,
      background:
        'linear-gradient(180deg, rgba(250, 250, 250, 0.0001) -74.5%, #FFF 41.44%)',
      zIndex: 1,
      filter: 'drop-shadow(-20px 15px 40px #fff)',
      boxShadow: '0 20px 5px #fff',
      pointerEvents: 'none',
    },
  },
  loadMoreBtn: {
    marginTop: '80px !important',
  },
}));

export const previewStyles = makeStyles(() => ({
  previewSec: {
    paddingTop: 100,
    paddingBottom: 100,
  },
  subtitle: {
    textAlign: 'center',
    marginBottom: 70,
    marginTop: 32,
  },
  gridContainer: {
    backgroundColor: '#EBE6E2',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
    gridTemplateRows: '1fr 1fr',
    gap: '0px 0px',
    gridTemplateAreas: `
      "primaryText primaryImage primaryImage tertriaryImage2 secondaryImage"
      "tertriaryImage1 primaryImage primaryImage secondaryText secondaryImage"
    `,
  },
  primaryImage: {
    gridArea: 'primaryImage',
  },
  secondaryImage: {
    gridArea: 'secondaryImage',
  },
  tertriaryImage1: {
    gridArea: 'tertriaryImage1',
  },
  tertriaryImage2: {
    gridArea: 'tertriaryImage2',
  },
  primaryText: {
    gridArea: 'primaryText',
    padding: 28,
    display: 'inline-flex',
    alignItems: 'center',
    background: '#CFC4C5',
    boxShadow: 'inset -10px 15px 20px rgba(81, 37, 37, 0.12)',
    textAlign: 'center',
    '& *': {
      lineHeight: '1.9!important',
    },
  },
  secondaryText: {
    gridArea: 'secondaryText',
    padding: 28,
    display: 'inline-flex',
    alignItems: 'center',
    textAlign: 'center',
    '& *': {
      lineHeight: '1.9!important',
    },
  },
  img: {
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  },
}));
